import React, {Component} from 'react';
import videoBG from '../../assets/img/videoBG.jpg';
import playImg from '../../assets/img/playBtn.png';
import styled from 'styled-components';

const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 35vw;
  z-index: 2;
  
  @media(min-width: 768px) {
    //height: 50vw;
  }
`;

const VideoBackground = styled.img`
  position: absolute;
  width: 100%;
  height: auto;
  top: 0;
  right: 0;
  left: 0;
  
  @media(min-width: 768px) {
    width: 100%;
    height: auto;
  }
`;

const PlayButton = styled.img`
  width: 50px;
  height: 50px;
  z-index: 1;
  cursor: pointer;
  
  @media(min-width: 768px) {
    width: auto;
    height: auto;
  }
`;


class VideoSection extends Component {
    render() {
        const {onClick} = this.props;
        return (
          <Container>
              <VideoBackground src={videoBG}/>
              <PlayButton src={playImg} onClick={onClick}/>
          </Container>
        );
    }
}

export default VideoSection;


// WEBPACK FOOTER //
// ./src/components/GetToKnow/VideoSection.js